import { createEvent } from "library/local-events/index.mjs"

export const MacroGuidanceOpen = createEvent("Authoring.OpenMacroGuidance")
export const MacroTokenValidationFailed = createEvent("MacroTokenValidationFailed")
export const ResolveMacroChipDisplay = createEvent("ResolveMacroChipDisplay")
export const MacroUpdated = createEvent("Authoring.MacroUpdated")
